/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** A valid URL, transported as a string */
  Url: { input: any; output: any; }
};

/** Autogenerated input type of AddCommentLikeMutation */
export type AddCommentLikeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddCommentLikeMutation. */
export type AddCommentLikeMutationPayload = {
  __typename?: 'AddCommentLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddCommentMutation */
export type AddCommentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contents: Scalars['String']['input'];
  videoId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddCommentMutation. */
export type AddCommentMutationPayload = {
  __typename?: 'AddCommentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddLikeMutation */
export type AddLikeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddLikeMutation. */
export type AddLikeMutationPayload = {
  __typename?: 'AddLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  like?: Maybe<Like>;
};

/** Autogenerated input type of AddPlaylistsVideoMutation */
export type AddPlaylistsVideoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  playlistId: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddPlaylistsVideoMutation. */
export type AddPlaylistsVideoMutationPayload = {
  __typename?: 'AddPlaylistsVideoMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlistsVideo: PlaylistsVideo;
};

/** Autogenerated input type of AddReplyLikeMutation */
export type AddReplyLikeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  replyId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddReplyLikeMutation. */
export type AddReplyLikeMutationPayload = {
  __typename?: 'AddReplyLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reply?: Maybe<Reply>;
};

/** Autogenerated input type of AddReplyMutation */
export type AddReplyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
  contents: Scalars['String']['input'];
  replyId?: InputMaybe<Scalars['ID']['input']>;
  videoId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddReplyMutation. */
export type AddReplyMutationPayload = {
  __typename?: 'AddReplyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reply?: Maybe<Reply>;
};

/** Autogenerated input type of AddSamansaTokenTicketMutation */
export type AddSamansaTokenTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddSamansaTokenTicketMutation. */
export type AddSamansaTokenTicketMutationPayload = {
  __typename?: 'AddSamansaTokenTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  samansaTokenTicket: Scalars['String']['output'];
};

/** Autogenerated return type of AddTestMovieMutation. */
export type AddTestMovieMutationPayload = {
  __typename?: 'AddTestMovieMutationPayload';
  movie: TestMovie;
};

export type AnyVideo = OriginalVideo | TrailerVideo;

/** The connection type for AnyVideo. */
export type AnyVideoConnection = {
  __typename?: 'AnyVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AnyVideoEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<AnyVideo>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AnyVideoEdge = {
  __typename?: 'AnyVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AnyVideo>;
};

/** Autogenerated input type of AttachPaymentMethodToCustomer */
export type AttachPaymentMethodToCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of AttachPaymentMethodToCustomer. */
export type AttachPaymentMethodToCustomerPayload = {
  __typename?: 'AttachPaymentMethodToCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AuthorizeSamansaTokenTicketMutation */
export type AuthorizeSamansaTokenTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  samansaTokenTicket: Scalars['String']['input'];
};

/** Autogenerated return type of AuthorizeSamansaTokenTicketMutation. */
export type AuthorizeSamansaTokenTicketMutationPayload = {
  __typename?: 'AuthorizeSamansaTokenTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  samansaTokenTicket: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rankable: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  videos?: Maybe<Array<OriginalVideo>>;
};

/** Autogenerated input type of CheckPaymentAuthentication */
export type CheckPaymentAuthenticationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CheckPaymentAuthentication. */
export type CheckPaymentAuthenticationPayload = {
  __typename?: 'CheckPaymentAuthenticationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  paymentClientSecret?: Maybe<Scalars['String']['output']>;
  setupClientSecret?: Maybe<Scalars['String']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  contents?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentUserHasLike?: Maybe<Scalars['Boolean']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isMine?: Maybe<Scalars['Boolean']['output']>;
  likeNum?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<ReplyConnection>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  videoId: Scalars['Int']['output'];
};


export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommentEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Comment>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Comment>;
};

/** The connection type for Reply. */
export type CommentRepliesConnection = {
  __typename?: 'CommentRepliesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommentRepliesEdge>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Reply>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CommentRepliesEdge = {
  __typename?: 'CommentRepliesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Reply>;
};

export enum CommentSortEnum {
  AscCreatedAt = 'ascCreatedAt',
  DescCreatedAt = 'descCreatedAt',
  DescLike = 'descLike'
}

export type Cookies = {
  __typename?: 'Cookies';
  cloudfrontKeyPairId: Scalars['String']['output'];
  cloudfrontPolicy: Scalars['String']['output'];
  cloudfrontSignature: Scalars['String']['output'];
  headerValue: Scalars['String']['output'];
};

/** Autogenerated input type of CreateCommentReportMutation */
export type CreateCommentReportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
  /** 報告理由: 1:いじめ・嫌がらせ, 2:児童虐待, 3:スパム, 4:ポルノ・ヌード, 5:ヘイトスピーチ, 6:その他 */
  reason: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateCommentReportMutation. */
export type CreateCommentReportMutationPayload = {
  __typename?: 'CreateCommentReportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateRecommendedPlaylistsMutation */
export type CreateRecommendedPlaylistsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateRecommendedPlaylistsMutation. */
export type CreateRecommendedPlaylistsMutationPayload = {
  __typename?: 'CreateRecommendedPlaylistsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlists: Array<Playlist>;
};

/** Autogenerated input type of CreateReplyReportMutation */
export type CreateReplyReportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['Int']['input'];
  replyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateReplyReportMutation. */
export type CreateReplyReportMutationPayload = {
  __typename?: 'CreateReplyReportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateSetupIntent */
export type CreateSetupIntentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSetupIntent. */
export type CreateSetupIntentPayload = {
  __typename?: 'CreateSetupIntentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  clientSecret: Scalars['String']['output'];
};

export type Creator = {
  __typename?: 'Creator';
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Duration = {
  __typename?: 'Duration';
  minuteUnitName?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  secondUnitName?: Maybe<Scalars['String']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of ExchangeSamansaTokenTicketMutation */
export type ExchangeSamansaTokenTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  samansaTokenTicket: Scalars['String']['input'];
};

/** Autogenerated return type of ExchangeSamansaTokenTicketMutation. */
export type ExchangeSamansaTokenTicketMutationPayload = {
  __typename?: 'ExchangeSamansaTokenTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  samansaToken: Scalars['String']['output'];
};

export enum FirebaseDeviceRegistrationTokenDeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Other = 'OTHER'
}

/** Autogenerated input type of HideScreenPopupMutation */
export type HideScreenPopupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  screenPopupId: Scalars['ID']['input'];
};

/** Autogenerated return type of HideScreenPopupMutation. */
export type HideScreenPopupMutationPayload = {
  __typename?: 'HideScreenPopupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userHiddenScreenPopup?: Maybe<UserHiddenScreenPopup>;
};

export type HomeScreen = {
  __typename?: 'HomeScreen';
  category?: Maybe<Category>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  videos?: Maybe<Array<OriginalVideo>>;
};

export type KeyVisual = {
  __typename?: 'KeyVisual';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  video?: Maybe<OriginalVideo>;
};

export type Like = {
  __typename?: 'Like';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  video?: Maybe<AnyVideo>;
};

/** The connection type for Like. */
export type LikeConnection = {
  __typename?: 'LikeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LikeEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Like>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type LikeEdge = {
  __typename?: 'LikeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Like>;
};

/** Autogenerated return type of LoginMutation. */
export type LoginMutationPayload = {
  __typename?: 'LoginMutationPayload';
  error?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MarkNotificationsAsReadMutation */
export type MarkNotificationsAsReadMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkNotificationsAsReadMutation. */
export type MarkNotificationsAsReadMutationPayload = {
  __typename?: 'MarkNotificationsAsReadMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addComment?: Maybe<AddCommentMutationPayload>;
  addCommentLike?: Maybe<AddCommentLikeMutationPayload>;
  addLike?: Maybe<AddLikeMutationPayload>;
  addPlaylistsVideo?: Maybe<AddPlaylistsVideoMutationPayload>;
  addReply?: Maybe<AddReplyMutationPayload>;
  addReplyLike?: Maybe<AddReplyLikeMutationPayload>;
  addSamansaTokenTicket?: Maybe<AddSamansaTokenTicketMutationPayload>;
  adminAddTestMovie?: Maybe<AddTestMovieMutationPayload>;
  adminLogin?: Maybe<LoginMutationPayload>;
  authorizeSamansaTokenTicket?: Maybe<AuthorizeSamansaTokenTicketMutationPayload>;
  createCommentReport?: Maybe<CreateCommentReportMutationPayload>;
  createRecommendedPlaylists?: Maybe<CreateRecommendedPlaylistsMutationPayload>;
  createReplyReport?: Maybe<CreateReplyReportMutationPayload>;
  exchangeSamansaTokenTicket?: Maybe<ExchangeSamansaTokenTicketMutationPayload>;
  hideScreenPopup?: Maybe<HideScreenPopupMutationPayload>;
  markNotificationsAsRead?: Maybe<MarkNotificationsAsReadMutationPayload>;
  removeComment?: Maybe<RemoveCommentMutationPayload>;
  removeCommentLike?: Maybe<RemoveCommentLikeMutationPayload>;
  removeLike?: Maybe<RemoveLikeMutationPayload>;
  removePlaylistsVideo?: Maybe<RemovePlaylistsVideoMutationPayload>;
  removeReply?: Maybe<RemoveReplyMutationPayload>;
  removeReplyLike?: Maybe<RemoveReplyLikeMutationPayload>;
  /** 視聴履歴を削除します */
  removeViewingTime?: Maybe<RemoveViewingTimeMutationPayload>;
  stripeAttachPaymentMethodToCustomer?: Maybe<AttachPaymentMethodToCustomerPayload>;
  stripeCheckPaymentAuthentication?: Maybe<CheckPaymentAuthenticationPayload>;
  stripeCreateSetupIntent?: Maybe<CreateSetupIntentPayload>;
  updateComment?: Maybe<UpdateCommentMutationPayload>;
  updateFirebaseDeviceRegistrationToken?: Maybe<UpdateFirebaseDeviceRegistrationTokenMutationPayload>;
  updateUserViewedTrailer?: Maybe<UpdateUserViewedTrailerMutationPayload>;
  updateViwewingTime?: Maybe<UpdateViewingTimeMutationPayload>;
  updateWithdrawalOtherReasons?: Maybe<UpdateWithdrawalOtherReasonsMutationPayload>;
  withdrawUser?: Maybe<WithdrawUserMutationPayload>;
};


export type MutationAddCommentArgs = {
  input: AddCommentMutationInput;
};


export type MutationAddCommentLikeArgs = {
  input: AddCommentLikeMutationInput;
};


export type MutationAddLikeArgs = {
  input: AddLikeMutationInput;
};


export type MutationAddPlaylistsVideoArgs = {
  input: AddPlaylistsVideoMutationInput;
};


export type MutationAddReplyArgs = {
  input: AddReplyMutationInput;
};


export type MutationAddReplyLikeArgs = {
  input: AddReplyLikeMutationInput;
};


export type MutationAddSamansaTokenTicketArgs = {
  input: AddSamansaTokenTicketMutationInput;
};


export type MutationAdminAddTestMovieArgs = {
  locale: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationAdminLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAuthorizeSamansaTokenTicketArgs = {
  input: AuthorizeSamansaTokenTicketMutationInput;
};


export type MutationCreateCommentReportArgs = {
  input: CreateCommentReportMutationInput;
};


export type MutationCreateRecommendedPlaylistsArgs = {
  input: CreateRecommendedPlaylistsMutationInput;
};


export type MutationCreateReplyReportArgs = {
  input: CreateReplyReportMutationInput;
};


export type MutationExchangeSamansaTokenTicketArgs = {
  input: ExchangeSamansaTokenTicketMutationInput;
};


export type MutationHideScreenPopupArgs = {
  input: HideScreenPopupMutationInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadMutationInput;
};


export type MutationRemoveCommentArgs = {
  input: RemoveCommentMutationInput;
};


export type MutationRemoveCommentLikeArgs = {
  input: RemoveCommentLikeMutationInput;
};


export type MutationRemoveLikeArgs = {
  input: RemoveLikeMutationInput;
};


export type MutationRemovePlaylistsVideoArgs = {
  input: RemovePlaylistsVideoMutationInput;
};


export type MutationRemoveReplyArgs = {
  input: RemoveReplyMutationInput;
};


export type MutationRemoveReplyLikeArgs = {
  input: RemoveReplyLikeMutationInput;
};


export type MutationRemoveViewingTimeArgs = {
  input: RemoveViewingTimeMutationInput;
};


export type MutationStripeAttachPaymentMethodToCustomerArgs = {
  input: AttachPaymentMethodToCustomerInput;
};


export type MutationStripeCheckPaymentAuthenticationArgs = {
  input: CheckPaymentAuthenticationInput;
};


export type MutationStripeCreateSetupIntentArgs = {
  input: CreateSetupIntentInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentMutationInput;
};


export type MutationUpdateFirebaseDeviceRegistrationTokenArgs = {
  input: UpdateFirebaseDeviceRegistrationTokenMutationInput;
};


export type MutationUpdateUserViewedTrailerArgs = {
  input: UpdateUserViewedTrailerMutationInput;
};


export type MutationUpdateViwewingTimeArgs = {
  input: UpdateViewingTimeMutationInput;
};


export type MutationUpdateWithdrawalOtherReasonsArgs = {
  input: UpdateWithdrawalOtherReasonsMutationInput;
};


export type MutationWithdrawUserArgs = {
  input: WithdrawUserMutationInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  notificationType: NotificationType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum NotificationFilter {
  All = 'ALL',
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum NotificationType {
  Announcement = 'ANNOUNCEMENT',
  CommentRecieved = 'COMMENT_RECIEVED',
  NewEvent = 'NEW_EVENT',
  NewFollower = 'NEW_FOLLOWER',
  ReviewLiked = 'REVIEW_LIKED'
}

export type OriginalVideo = Video & {
  __typename?: 'OriginalVideo';
  categories?: Maybe<Array<Category>>;
  comment?: Maybe<Comment>;
  commentaryUrl?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentConnection>;
  commentsCount: Scalars['Int']['output'];
  contentEnd?: Maybe<Duration>;
  cookies?: Maybe<Cookies>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<Creator>;
  currentUserHasLike?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drmDashFileUrl?: Maybe<Scalars['String']['output']>;
  drmHlsFileUrl?: Maybe<Scalars['String']['output']>;
  duration: Duration;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filmarksUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  landscapeThumbnail?: Maybe<Scalars['String']['output']>;
  likeNum: Scalars['Int']['output'];
  nextVideo?: Maybe<OriginalVideo>;
  playlists?: Maybe<Array<Playlist>>;
  playlistsVideos?: Maybe<Array<PlaylistsVideo>>;
  portraitThumbnail?: Maybe<Scalars['String']['output']>;
  recommends?: Maybe<Array<OriginalVideo>>;
  status: VideoStatusEnum;
  subtitles?: Maybe<Array<SrtSubtitle>>;
  thumbnailCategory?: Maybe<Category>;
  title?: Maybe<Scalars['String']['output']>;
  trailer?: Maybe<TrailerVideo>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewingTime?: Maybe<VideoViewingTime>;
  vtts?: Maybe<Array<VttSubtitle>>;
  willBePublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type OriginalVideoCommentArgs = {
  id: Scalars['ID']['input'];
};


export type OriginalVideoCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for OriginalVideo. */
export type OriginalVideoConnection = {
  __typename?: 'OriginalVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OriginalVideoEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<OriginalVideo>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type OriginalVideoEdge = {
  __typename?: 'OriginalVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OriginalVideo>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  nextPaymentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentType: PaymentTypeEnum;
};

export enum PaymentTypeEnum {
  Android = 'android',
  Ios = 'ios',
  NoSubscription = 'no_subscription',
  Stripe = 'stripe'
}

export type Playlist = {
  __typename?: 'Playlist';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  rowOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userId: Scalars['Int']['output'];
  videos?: Maybe<AnyVideoConnection>;
};


export type PlaylistVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaylistsVideo = {
  __typename?: 'PlaylistsVideo';
  id: Scalars['ID']['output'];
  playlist: Playlist;
};

export type PromotionCode = {
  __typename?: 'PromotionCode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  redeemBy?: Maybe<Scalars['ISO8601Date']['output']>;
  redeemFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adminTestMovies: Array<TestMovie>;
  category: Category;
  commentReplies: CommentRepliesConnection;
  currentUser?: Maybe<User>;
  homeScreens: Array<HomeScreen>;
  keyVisuals: Array<KeyVisual>;
  notifications?: Maybe<Array<Notification>>;
  originalVideo?: Maybe<OriginalVideo>;
  payment: Payment;
  playlists: Array<Playlist>;
  promotionCode?: Maybe<PromotionCode>;
  recommendedSearchKeywords: Array<RecommendedSearchKeyword>;
  rootCategories: Array<RootCategory>;
  screenPopups: ScreenPopupConnection;
  trailerVideo?: Maybe<TrailerVideo>;
  trailerVideos: TrailerVideoConnection;
  tvSearchCategories: Array<TvSearchCategory>;
  videoComments: VideoCommentsConnection;
  videoRecommends?: Maybe<VideoRecommendsConnection>;
  withdrawalVideos: Array<WithdrawalVideo>;
};


export type QueryAdminTestMoviesArgs = {
  locale: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHomeScreensArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNotificationsArgs = {
  notificationFilter?: InputMaybe<NotificationFilter>;
};


export type QueryOriginalVideoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryScreenPopupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  displayMethod?: InputMaybe<ScreenPopupDisplayMethod>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTrailerVideoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrailerVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideoCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommentSortEnum>;
};


export type QueryVideoRecommendsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RecommendedSearchKeyword = {
  __typename?: 'RecommendedSearchKeyword';
  createdAt: Scalars['ISO8601DateTime']['output'];
  keyword: Scalars['String']['output'];
  rowOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of RemoveCommentLikeMutation */
export type RemoveCommentLikeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCommentLikeMutation. */
export type RemoveCommentLikeMutationPayload = {
  __typename?: 'RemoveCommentLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveCommentMutation */
export type RemoveCommentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCommentMutation. */
export type RemoveCommentMutationPayload = {
  __typename?: 'RemoveCommentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveLikeMutation */
export type RemoveLikeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveLikeMutation. */
export type RemoveLikeMutationPayload = {
  __typename?: 'RemoveLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  like?: Maybe<Like>;
};

/** Autogenerated input type of RemovePlaylistsVideoMutation */
export type RemovePlaylistsVideoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  playlistId: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemovePlaylistsVideoMutation. */
export type RemovePlaylistsVideoMutationPayload = {
  __typename?: 'RemovePlaylistsVideoMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlistsVideo?: Maybe<PlaylistsVideo>;
};

/** Autogenerated input type of RemoveReplyLikeMutation */
export type RemoveReplyLikeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  replyId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveReplyLikeMutation. */
export type RemoveReplyLikeMutationPayload = {
  __typename?: 'RemoveReplyLikeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reply?: Maybe<Reply>;
};

/** Autogenerated input type of RemoveReplyMutation */
export type RemoveReplyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveReplyMutation. */
export type RemoveReplyMutationPayload = {
  __typename?: 'RemoveReplyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reply?: Maybe<Reply>;
};

/** Autogenerated input type of RemoveViewingTimeMutation */
export type RemoveViewingTimeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 削除する視聴履歴のID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveViewingTimeMutation. */
export type RemoveViewingTimeMutationPayload = {
  __typename?: 'RemoveViewingTimeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  viewingTime?: Maybe<VideoViewingTime>;
};

export type Reply = {
  __typename?: 'Reply';
  commentId: Scalars['Int']['output'];
  contents?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentUserHasLike?: Maybe<Scalars['Boolean']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isMine?: Maybe<Scalars['Boolean']['output']>;
  likeNum?: Maybe<Scalars['Int']['output']>;
  replyOfReplyId?: Maybe<Scalars['Int']['output']>;
  replyToUser?: Maybe<User>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/** The connection type for Reply. */
export type ReplyConnection = {
  __typename?: 'ReplyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReplyEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Reply>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ReplyEdge = {
  __typename?: 'ReplyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Reply>;
};

export type RootCategory = {
  __typename?: 'RootCategory';
  categories?: Maybe<Array<Category>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ScreenPopup = {
  __typename?: 'ScreenPopup';
  button?: Maybe<ScreenPopupButton>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayMethod: ScreenPopupDisplayMethod;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  isSensitive: Scalars['Boolean']['output'];
  pcImage?: Maybe<Scalars['String']['output']>;
  publicationFrom: Scalars['ISO8601DateTime']['output'];
  publicationTo: Scalars['ISO8601DateTime']['output'];
  rowOrderRank: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ScreenPopupButton = {
  __typename?: 'ScreenPopupButton';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  screenPopupId: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  textColor: Scalars['String']['output'];
  url?: Maybe<Scalars['Url']['output']>;
  video?: Maybe<OriginalVideo>;
};

/** The connection type for ScreenPopup. */
export type ScreenPopupConnection = {
  __typename?: 'ScreenPopupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScreenPopupEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<ScreenPopup>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ScreenPopupDisplayMethod {
  KeyVisual = 'KEY_VISUAL',
  Popup = 'POPUP'
}

/** An edge in a connection. */
export type ScreenPopupEdge = {
  __typename?: 'ScreenPopupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScreenPopup>;
};

export type SrtSubtitle = {
  __typename?: 'SrtSubtitle';
  default: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TestMovie = {
  __typename?: 'TestMovie';
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TrailerVideo = Video & {
  __typename?: 'TrailerVideo';
  categories?: Maybe<Array<Category>>;
  comment?: Maybe<Comment>;
  commentaryUrl?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentConnection>;
  commentsCount: Scalars['Int']['output'];
  cookies?: Maybe<Cookies>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<Creator>;
  currentUserHasLike?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drmDashFileUrl?: Maybe<Scalars['String']['output']>;
  drmHlsFileUrl?: Maybe<Scalars['String']['output']>;
  duration: Duration;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filmarksUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  landscapeThumbnail?: Maybe<Scalars['String']['output']>;
  likeNum: Scalars['Int']['output'];
  nextVideo?: Maybe<OriginalVideo>;
  original?: Maybe<OriginalVideo>;
  playlists?: Maybe<Array<Playlist>>;
  portraitThumbnail?: Maybe<Scalars['String']['output']>;
  status: VideoStatusEnum;
  subtitles?: Maybe<Array<SrtSubtitle>>;
  thumbnailCategory?: Maybe<Category>;
  title?: Maybe<Scalars['String']['output']>;
  trailerPriority?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewingTime?: Maybe<VideoViewingTime>;
  vtts?: Maybe<Array<VttSubtitle>>;
  willBePublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type TrailerVideoCommentArgs = {
  id: Scalars['ID']['input'];
};


export type TrailerVideoCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for TrailerVideo. */
export type TrailerVideoConnection = {
  __typename?: 'TrailerVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TrailerVideoEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<TrailerVideo>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TrailerVideoEdge = {
  __typename?: 'TrailerVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TrailerVideo>;
};

export type TvSearchCategory = {
  __typename?: 'TvSearchCategory';
  category?: Maybe<Category>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of UpdateCommentMutation */
export type UpdateCommentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contents: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCommentMutation. */
export type UpdateCommentMutationPayload = {
  __typename?: 'UpdateCommentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateFirebaseDeviceRegistrationTokenMutation */
export type UpdateFirebaseDeviceRegistrationTokenMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceType: FirebaseDeviceRegistrationTokenDeviceType;
  firebaseDeviceRegistrationToken: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFirebaseDeviceRegistrationTokenMutation. */
export type UpdateFirebaseDeviceRegistrationTokenMutationPayload = {
  __typename?: 'UpdateFirebaseDeviceRegistrationTokenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateUserViewedTrailerMutation */
export type UpdateUserViewedTrailerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trailerVideoId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserViewedTrailerMutation. */
export type UpdateUserViewedTrailerMutationPayload = {
  __typename?: 'UpdateUserViewedTrailerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateViewingTimeMutation */
export type UpdateViewingTimeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
  viewingMin: Scalars['Int']['input'];
  viewingSecond: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateViewingTimeMutation. */
export type UpdateViewingTimeMutationPayload = {
  __typename?: 'UpdateViewingTimeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  viewingTime?: Maybe<VideoViewingTime>;
};

/** Autogenerated input type of UpdateWithdrawalOtherReasonsMutation */
export type UpdateWithdrawalOtherReasonsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otherReasons: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateWithdrawalOtherReasonsMutation. */
export type UpdateWithdrawalOtherReasonsMutationPayload = {
  __typename?: 'UpdateWithdrawalOtherReasonsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  withdrawal?: Maybe<Withdrawal>;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  freeTrialEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasSubscription?: Maybe<Scalars['Boolean']['output']>;
  histories?: Maybe<OriginalVideoConnection>;
  id: Scalars['ID']['output'];
  isSelf?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<LikeConnection>;
  mailDesired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userStatus?: Maybe<Scalars['String']['output']>;
};


export type UserHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserLikesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHiddenScreenPopup = {
  __typename?: 'UserHiddenScreenPopup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  screenPopup: ScreenPopup;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type Video = {
  categories?: Maybe<Array<Category>>;
  comment?: Maybe<Comment>;
  commentaryUrl?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentConnection>;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<Creator>;
  currentUserHasLike?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drmDashFileUrl?: Maybe<Scalars['String']['output']>;
  drmHlsFileUrl?: Maybe<Scalars['String']['output']>;
  duration: Duration;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filmarksUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  landscapeThumbnail?: Maybe<Scalars['String']['output']>;
  likeNum: Scalars['Int']['output'];
  nextVideo?: Maybe<OriginalVideo>;
  playlists?: Maybe<Array<Playlist>>;
  portraitThumbnail?: Maybe<Scalars['String']['output']>;
  status: VideoStatusEnum;
  subtitles?: Maybe<Array<SrtSubtitle>>;
  thumbnailCategory?: Maybe<Category>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewingTime?: Maybe<VideoViewingTime>;
  vtts?: Maybe<Array<VttSubtitle>>;
  willBePublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type VideoCommentArgs = {
  id: Scalars['ID']['input'];
};


export type VideoCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Comment. */
export type VideoCommentsConnection = {
  __typename?: 'VideoCommentsConnection';
  allCount?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<VideoCommentsEdge>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Comment>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type VideoCommentsEdge = {
  __typename?: 'VideoCommentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Comment>;
};

/** The connection type for OriginalVideo. */
export type VideoRecommendsConnection = {
  __typename?: 'VideoRecommendsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VideoRecommendsEdge>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<OriginalVideo>>;
  /** Information to aid in pagination. */
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type VideoRecommendsEdge = {
  __typename?: 'VideoRecommendsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OriginalVideo>;
};

export enum VideoStatusEnum {
  Published = 'published',
  Unpublished = 'unpublished',
  Upcoming = 'upcoming'
}

export type VideoViewingTime = {
  __typename?: 'VideoViewingTime';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isViewed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  viewingMin?: Maybe<Scalars['Int']['output']>;
  viewingSecond?: Maybe<Scalars['Int']['output']>;
};

export type VttSubtitle = {
  __typename?: 'VttSubtitle';
  default: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of WithdrawUserMutation */
export type WithdrawUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WithdrawUserMutation. */
export type WithdrawUserMutationPayload = {
  __typename?: 'WithdrawUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentPeriodEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  hasAppleSubscription: Scalars['Boolean']['output'];
  paymentType: Scalars['String']['output'];
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  createdAt: Scalars['ISO8601DateTime']['output'];
  duringFreeTrial: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  otherReasons?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type WithdrawalVideo = {
  __typename?: 'WithdrawalVideo';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  video: TrailerVideo;
};

export type StripeCheckPaymentAuthenticationMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeCheckPaymentAuthenticationMutation = { __typename?: 'Mutation', stripeCheckPaymentAuthentication?: { __typename?: 'CheckPaymentAuthenticationPayload', setupClientSecret?: string | null, paymentClientSecret?: string | null } | null };

export type AuthorizeSamansaTokenTicketMutationVariables = Exact<{
  samansaTokenTicket: Scalars['String']['input'];
}>;


export type AuthorizeSamansaTokenTicketMutation = { __typename?: 'Mutation', authorizeSamansaTokenTicket?: { __typename?: 'AuthorizeSamansaTokenTicketMutationPayload', samansaTokenTicket: string } | null };

export type GetHomeGenresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeGenresQuery = { __typename?: 'Query', rootCategories: Array<{ __typename?: 'RootCategory', id: string, name?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name?: string | null, rankable: boolean }> | null }> };

export type GetCurrentUserWithEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserWithEmailQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string } | null };

export type GetHomeScreenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetHomeScreenQuery = { __typename?: 'Query', homeScreens: Array<{ __typename?: 'HomeScreen', id: string, videos?: Array<{ __typename?: 'OriginalVideo', id: string, status: VideoStatusEnum, landscapeThumbnail?: string | null, portraitThumbnail?: string | null, duration: { __typename?: 'Duration', minutes?: number | null, seconds?: number | null }, viewingTime?: { __typename?: 'VideoViewingTime', id: string, viewingMin?: number | null, viewingSecond?: number | null } | null }> | null }> };

export type GetHomeScreensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeScreensQuery = { __typename?: 'Query', homeScreens: Array<{ __typename?: 'HomeScreen', id: string, category?: { __typename?: 'Category', id: string, rankable: boolean, name?: string | null } | null }> };

export type StripeCreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeCreateSetupIntentMutation = { __typename?: 'Mutation', stripeCreateSetupIntent?: { __typename?: 'CreateSetupIntentPayload', clientSecret: string } | null };

export type StripeAttachPaymentMethodToCustomerMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type StripeAttachPaymentMethodToCustomerMutation = { __typename?: 'Mutation', stripeAttachPaymentMethodToCustomer?: { __typename?: 'AttachPaymentMethodToCustomerPayload', success: boolean } | null };

export type GetPromotionCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetPromotionCodeQuery = { __typename?: 'Query', promotionCode?: { __typename?: 'PromotionCode', id: string, code: string, name: string, redeemBy?: any | null, redeemFrom?: any | null, unavailableReason?: string | null } | null };

export type HideScreenPopupMutationVariables = Exact<{
  screenPopupId: Scalars['ID']['input'];
}>;


export type HideScreenPopupMutation = { __typename?: 'Mutation', hideScreenPopup?: { __typename?: 'HideScreenPopupMutationPayload', errors: Array<string>, userHiddenScreenPopup?: { __typename?: 'UserHiddenScreenPopup', id: string, createdAt: any, updatedAt: any, screenPopup: { __typename?: 'ScreenPopup', id: string }, user: { __typename?: 'User', id: string } } | null } | null };

export type GetKeyVisualsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetKeyVisualsQuery = { __typename?: 'Query', screenPopups: { __typename?: 'ScreenPopupConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'ScreenPopupEdge', cursor: string, node?: { __typename?: 'ScreenPopup', id: string, title: string, image: string, createdAt: any, updatedAt: any, button?: { __typename?: 'ScreenPopupButton', color: string, text?: string | null, textColor: string, url?: any | null, video?: { __typename?: 'OriginalVideo', id: string, landscapeThumbnail?: string | null, title?: string | null, description?: string | null, duration: { __typename?: 'Duration', minutes?: number | null, seconds?: number | null } } | null } | null } | null }> | null } };

export type GetScreenPopupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetScreenPopupsQuery = { __typename?: 'Query', screenPopups: { __typename?: 'ScreenPopupConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'ScreenPopupEdge', cursor: string, node?: { __typename?: 'ScreenPopup', id: string, title: string, image: string, rowOrderRank: number, createdAt: any, updatedAt: any, button?: { __typename?: 'ScreenPopupButton', color: string, text?: string | null, textColor: string, url?: any | null, video?: { __typename?: 'OriginalVideo', id: string } | null } | null } | null }> | null } };

export type GetVideoPreviewModalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVideoPreviewModalQuery = { __typename?: 'Query', originalVideo?: { __typename?: 'OriginalVideo', id: string, status: VideoStatusEnum, title?: string | null, description?: string | null, willBePublishedAt?: any | null, creator?: { __typename?: 'Creator', avatar?: string | null, name?: string | null } | null, duration: { __typename?: 'Duration', minuteUnitName?: string | null, minutes?: number | null, secondUnitName?: string | null, seconds?: number | null }, subtitles?: Array<{ __typename?: 'SrtSubtitle', label: string, url: string, default: boolean, locale: string }> | null, trailer?: { __typename?: 'TrailerVideo', id: string, description?: string | null, fileUrl?: string | null, vtts?: Array<{ __typename?: 'VttSubtitle', default: boolean, locale: string, label: string, url: string }> | null, subtitles?: Array<{ __typename?: 'SrtSubtitle', label: string, default: boolean, locale: string, url: string }> | null } | null } | null };

export type AddCommentMutationVariables = Exact<{
  videoId: Scalars['ID']['input'];
  contents: Scalars['String']['input'];
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment?: { __typename?: 'AddCommentMutationPayload', errors: Array<string>, comment?: { __typename?: 'Comment', id: string, videoId: number, userId: number, contents?: string | null, isMine?: boolean | null, createdAt?: any | null, user?: { __typename?: 'User', id: string, name?: string | null, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null } | null, replies?: { __typename?: 'ReplyConnection', totalCount?: number | null } | null } | null } | null };

export type RemoveCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveCommentMutation = { __typename?: 'Mutation', removeComment?: { __typename?: 'RemoveCommentMutationPayload', errors: Array<string>, comment?: { __typename?: 'Comment', id: string } | null } | null };

export type AddCommentLikeMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type AddCommentLikeMutation = { __typename?: 'Mutation', addCommentLike?: { __typename?: 'AddCommentLikeMutationPayload', errors: Array<string>, comment?: { __typename?: 'Comment', id: string, currentUserHasLike?: boolean | null, likeNum?: number | null } | null } | null };

export type AddLikeMutationVariables = Exact<{
  videoId: Scalars['ID']['input'];
}>;


export type AddLikeMutation = { __typename?: 'Mutation', addLike?: { __typename?: 'AddLikeMutationPayload', errors: Array<string>, like?: { __typename?: 'Like', id: string } | null } | null };

export type AddReplyLikeMutationVariables = Exact<{
  replyId: Scalars['ID']['input'];
}>;


export type AddReplyLikeMutation = { __typename?: 'Mutation', addReplyLike?: { __typename?: 'AddReplyLikeMutationPayload', errors: Array<string>, reply?: { __typename?: 'Reply', id: string, currentUserHasLike?: boolean | null, likeNum?: number | null } | null } | null };

export type RemoveCommentLikeMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type RemoveCommentLikeMutation = { __typename?: 'Mutation', removeCommentLike?: { __typename?: 'RemoveCommentLikeMutationPayload', errors: Array<string>, comment?: { __typename?: 'Comment', id: string, currentUserHasLike?: boolean | null, likeNum?: number | null } | null } | null };

export type RemoveLikeMutationVariables = Exact<{
  videoId: Scalars['ID']['input'];
}>;


export type RemoveLikeMutation = { __typename?: 'Mutation', removeLike?: { __typename?: 'RemoveLikeMutationPayload', errors: Array<string>, like?: { __typename?: 'Like', id: string } | null } | null };

export type RemoveReplyLikeMutationVariables = Exact<{
  replyId: Scalars['ID']['input'];
}>;


export type RemoveReplyLikeMutation = { __typename?: 'Mutation', removeReplyLike?: { __typename?: 'RemoveReplyLikeMutationPayload', errors: Array<string>, reply?: { __typename?: 'Reply', id: string, currentUserHasLike?: boolean | null, likeNum?: number | null } | null } | null };

export type AddReplyMutationVariables = Exact<{
  videoId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
  replyId?: InputMaybe<Scalars['ID']['input']>;
  contents: Scalars['String']['input'];
}>;


export type AddReplyMutation = { __typename?: 'Mutation', addReply?: { __typename?: 'AddReplyMutationPayload', errors: Array<string>, reply?: { __typename?: 'Reply', id: string, commentId: number, contents?: string | null, updatedAt?: any | null, isMine?: boolean | null, userId: number, createdAt?: any | null, replyOfReplyId?: number | null, user?: { __typename?: 'User', id: string, name?: string | null, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null } | null, replyToUser?: { __typename?: 'User', id: string, name?: string | null, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type RemoveReplyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveReplyMutation = { __typename?: 'Mutation', removeReply?: { __typename?: 'RemoveReplyMutationPayload', errors: Array<string>, reply?: { __typename?: 'Reply', id: string } | null } | null };

export type UpdateViwewingTimeMutationVariables = Exact<{
  videoId: Scalars['ID']['input'];
  viewingMin: Scalars['Int']['input'];
  viewingSecond: Scalars['Int']['input'];
}>;


export type UpdateViwewingTimeMutation = { __typename?: 'Mutation', updateViwewingTime?: { __typename?: 'UpdateViewingTimeMutationPayload', errors: Array<string> } | null };

export type GetCommentRepliesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommentRepliesQuery = { __typename?: 'Query', commentReplies: { __typename?: 'CommentRepliesConnection', id: string, totalCount?: number | null, pageInfo?: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } | null, edges?: Array<{ __typename?: 'CommentRepliesEdge', cursor: string, node?: { __typename?: 'Reply', id: string, commentId: number, contents?: string | null, updatedAt?: any | null, isMine?: boolean | null, userId: number, createdAt?: any | null, replyOfReplyId?: number | null, currentUserHasLike?: boolean | null, likeNum?: number | null, user?: { __typename?: 'User', id: string, name?: string | null, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null } | null, replyToUser?: { __typename?: 'User', id: string, name?: string | null, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null }> | null } };

export type CommentRepliesFragment = { __typename?: 'Comment', replies?: { __typename?: 'ReplyConnection', totalCount?: number | null } | null } & { ' $fragmentName'?: 'CommentRepliesFragment' };

export type ReplyLikeFragment = { __typename?: 'Reply', currentUserHasLike?: boolean | null, likeNum?: number | null } & { ' $fragmentName'?: 'ReplyLikeFragment' };

export type GetOriginalVideoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOriginalVideoQuery = { __typename?: 'Query', originalVideo?: { __typename?: 'OriginalVideo', currentUserHasLike?: boolean | null, likeNum: number, commentaryUrl?: string | null, filmarksUrl?: string | null, description?: string | null, fileUrl?: string | null, id: string, landscapeThumbnail?: string | null, portraitThumbnail?: string | null, title?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name?: string | null }> | null, creator?: { __typename?: 'Creator', avatar?: string | null, id: string, name?: string | null } | null, duration: { __typename?: 'Duration', minutes?: number | null, minuteUnitName?: string | null, seconds?: number | null, secondUnitName?: string | null }, subtitles?: Array<{ __typename?: 'SrtSubtitle', default: boolean, label: string, locale: string, url: string }> | null, viewingTime?: { __typename?: 'VideoViewingTime', isViewed?: boolean | null, viewingMin?: number | null, viewingSecond?: number | null } | null, vtts?: Array<{ __typename?: 'VttSubtitle', default: boolean, label: string, locale: string, url: string }> | null, nextVideo?: { __typename?: 'OriginalVideo', id: string, title?: string | null, description?: string | null, landscapeThumbnail?: string | null, portraitThumbnail?: string | null, duration: { __typename?: 'Duration', minutes?: number | null, minuteUnitName?: string | null, seconds?: number | null, secondUnitName?: string | null }, viewingTime?: { __typename?: 'VideoViewingTime', isViewed?: boolean | null, viewingMin?: number | null, viewingSecond?: number | null } | null } | null, trailer?: { __typename?: 'TrailerVideo', id: string, fileUrl?: string | null, vtts?: Array<{ __typename?: 'VttSubtitle', default: boolean, label: string, locale: string, url: string }> | null } | null } | null };

export type GetOriginalVideoCookieQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOriginalVideoCookieQuery = { __typename?: 'Query', originalVideo?: { __typename?: 'OriginalVideo', fileUrl?: string | null, id: string, cookies?: { __typename?: 'Cookies', headerValue: string } | null } | null };

export type GetVideoCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVideoCommentsQuery = { __typename?: 'Query', videoComments: { __typename?: 'VideoCommentsConnection', id: string, allCount?: number | null, pageInfo?: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } | null, edges?: Array<{ __typename?: 'VideoCommentsEdge', cursor: string, node?: { __typename?: 'Comment', id: string, videoId: number, userId: number, contents?: string | null, isMine?: boolean | null, createdAt?: any | null, currentUserHasLike?: boolean | null, likeNum?: number | null, user?: { __typename?: 'User', id: string, name?: string | null, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null } | null, replies?: { __typename?: 'ReplyConnection', totalCount?: number | null } | null } | null }> | null } };

export type CommentLikeFragment = { __typename?: 'Comment', currentUserHasLike?: boolean | null, likeNum?: number | null } & { ' $fragmentName'?: 'CommentLikeFragment' };

export type GetVideoLikeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVideoLikeQuery = { __typename?: 'Query', originalVideo?: { __typename?: 'OriginalVideo', id: string, currentUserHasLike?: boolean | null, likeNum: number } | null };

export type GetVideoRecommendsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVideoRecommendsQuery = { __typename?: 'Query', videoRecommends?: { __typename?: 'VideoRecommendsConnection', id: string, edges?: Array<{ __typename?: 'VideoRecommendsEdge', cursor: string, node?: { __typename?: 'OriginalVideo', id: string, title?: string | null, description?: string | null, portraitThumbnail?: string | null, landscapeThumbnail?: string | null, viewingTime?: { __typename?: 'VideoViewingTime', viewingMin?: number | null, viewingSecond?: number | null } | null, duration: { __typename?: 'Duration', minuteUnitName?: string | null, minutes?: number | null, secondUnitName?: string | null, seconds?: number | null }, creator?: { __typename?: 'Creator', id: string, name?: string | null, avatar?: string | null } | null } | null }> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean } | null } | null };

export const CommentRepliesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentReplies"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CommentRepliesFragment, unknown>;
export const ReplyLikeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReplyLike"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Reply"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}}]} as unknown as DocumentNode<ReplyLikeFragment, unknown>;
export const CommentLikeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentLike"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}}]} as unknown as DocumentNode<CommentLikeFragment, unknown>;
export const StripeCheckPaymentAuthenticationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeCheckPaymentAuthentication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCheckPaymentAuthentication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupClientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentClientSecret"}}]}}]}}]} as unknown as DocumentNode<StripeCheckPaymentAuthenticationMutation, StripeCheckPaymentAuthenticationMutationVariables>;
export const AuthorizeSamansaTokenTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authorizeSamansaTokenTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"samansaTokenTicket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizeSamansaTokenTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"samansaTokenTicket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"samansaTokenTicket"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"samansaTokenTicket"}}]}}]}}]} as unknown as DocumentNode<AuthorizeSamansaTokenTicketMutation, AuthorizeSamansaTokenTicketMutationVariables>;
export const GetHomeGenresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHomeGenres"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rankable"}}]}}]}}]}}]} as unknown as DocumentNode<GetHomeGenresQuery, GetHomeGenresQueryVariables>;
export const GetCurrentUserWithEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUserWithEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserWithEmailQuery, GetCurrentUserWithEmailQueryVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetHomeScreenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHomeScreen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homeScreens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewingTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewingMin"}},{"kind":"Field","name":{"kind":"Name","value":"viewingSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landscapeThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"portraitThumbnail"}}]}}]}}]}}]} as unknown as DocumentNode<GetHomeScreenQuery, GetHomeScreenQueryVariables>;
export const GetHomeScreensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHomeScreens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homeScreens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rankable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetHomeScreensQuery, GetHomeScreensQueryVariables>;
export const StripeCreateSetupIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeCreateSetupIntent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCreateSetupIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<StripeCreateSetupIntentMutation, StripeCreateSetupIntentMutationVariables>;
export const StripeAttachPaymentMethodToCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeAttachPaymentMethodToCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeAttachPaymentMethodToCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<StripeAttachPaymentMethodToCustomerMutation, StripeAttachPaymentMethodToCustomerMutationVariables>;
export const GetPromotionCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPromotionCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotionCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"redeemBy"}},{"kind":"Field","name":{"kind":"Name","value":"redeemFrom"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableReason"}}]}}]}}]} as unknown as DocumentNode<GetPromotionCodeQuery, GetPromotionCodeQueryVariables>;
export const HideScreenPopupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"hideScreenPopup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"screenPopupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideScreenPopup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"screenPopupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"screenPopupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userHiddenScreenPopup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"screenPopup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<HideScreenPopupMutation, HideScreenPopupMutationVariables>;
export const GetKeyVisualsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getKeyVisuals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"screenPopups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayMethod"},"value":{"kind":"EnumValue","value":"KEY_VISUAL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"button"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"landscapeThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKeyVisualsQuery, GetKeyVisualsQueryVariables>;
export const GetScreenPopupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getScreenPopups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"screenPopups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayMethod"},"value":{"kind":"EnumValue","value":"POPUP"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"rowOrderRank"}},{"kind":"Field","name":{"kind":"Name","value":"button"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetScreenPopupsQuery, GetScreenPopupsQueryVariables>;
export const GetVideoPreviewModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVideoPreviewModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"willBePublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minuteUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"secondUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"vtts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtitles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVideoPreviewModalQuery, GetVideoPreviewModalQueryVariables>;
export const AddCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contents"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contents"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"contents"}},{"kind":"Field","name":{"kind":"Name","value":"isMine"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddCommentMutation, AddCommentMutationVariables>;
export const RemoveCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RemoveCommentMutation, RemoveCommentMutationVariables>;
export const AddCommentLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCommentLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCommentLike"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"commentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddCommentLikeMutation, AddCommentLikeMutationVariables>;
export const AddLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addLike"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"like"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddLikeMutation, AddLikeMutationVariables>;
export const AddReplyLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addReplyLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addReplyLike"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"replyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddReplyLikeMutation, AddReplyLikeMutationVariables>;
export const RemoveCommentLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCommentLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCommentLike"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"commentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RemoveCommentLikeMutation, RemoveCommentLikeMutationVariables>;
export const RemoveLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeLike"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"like"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RemoveLikeMutation, RemoveLikeMutationVariables>;
export const RemoveReplyLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeReplyLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeReplyLike"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"replyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RemoveReplyLikeMutation, RemoveReplyLikeMutationVariables>;
export const AddReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contents"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addReply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"commentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"replyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contents"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"contents"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMine"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replyToUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"replyOfReplyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddReplyMutation, AddReplyMutationVariables>;
export const RemoveReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeReply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RemoveReplyMutation, RemoveReplyMutationVariables>;
export const UpdateViwewingTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateViwewingTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewingMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewingSecond"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateViwewingTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"videoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"videoId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewingMin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewingMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewingSecond"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewingSecond"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateViwewingTimeMutation, UpdateViwewingTimeMutationVariables>;
export const GetCommentRepliesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCommentReplies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentReplies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"contents"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMine"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replyToUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"replyOfReplyId"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCommentRepliesQuery, GetCommentRepliesQueryVariables>;
export const GetOriginalVideoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOriginalVideo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}},{"kind":"Field","name":{"kind":"Name","value":"commentaryUrl"}},{"kind":"Field","name":{"kind":"Name","value":"filmarksUrl"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"minuteUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"secondUnitName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"landscapeThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"portraitThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"subtitles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"viewingTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isViewed"}},{"kind":"Field","name":{"kind":"Name","value":"viewingMin"}},{"kind":"Field","name":{"kind":"Name","value":"viewingSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vtts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"landscapeThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"portraitThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"minuteUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"secondUnitName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewingTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isViewed"}},{"kind":"Field","name":{"kind":"Name","value":"viewingMin"}},{"kind":"Field","name":{"kind":"Name","value":"viewingSecond"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"vtts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOriginalVideoQuery, GetOriginalVideoQueryVariables>;
export const GetOriginalVideoCookieDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOriginalVideoCookie"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cookies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headerValue"}}]}}]}}]}}]} as unknown as DocumentNode<GetOriginalVideoCookieQuery, GetOriginalVideoCookieQueryVariables>;
export const GetVideoCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVideoComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"contents"}},{"kind":"Field","name":{"kind":"Name","value":"isMine"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVideoCommentsQuery, GetVideoCommentsQueryVariables>;
export const GetVideoLikeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVideoLike"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserHasLike"}},{"kind":"Field","name":{"kind":"Name","value":"likeNum"}}]}}]}}]} as unknown as DocumentNode<GetVideoLikeQuery, GetVideoLikeQueryVariables>;
export const GetVideoRecommendsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVideoRecommends"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoRecommends"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"portraitThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"landscapeThumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"viewingTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingMin"}},{"kind":"Field","name":{"kind":"Name","value":"viewingSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minuteUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"secondUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetVideoRecommendsQuery, GetVideoRecommendsQueryVariables>;